import React, { useState } from "react";
import { Table, notification, Avatar, Modal } from "antd";
import styled from "styled-components";
import API_URL from "../../config";

const axios = require("axios").default;

const PageWrap = styled.div`
  padding: 24px;
`;

const TopRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 500;
  color: #555;
`;

const DateInput = styled.input`
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 14px;
  outline: none;
  &:focus { border-color: #ae094d; }
`;

const SearchButton = styled.button`
  background: #ae094d;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 7px 20px;
  font-size: 14px;
  cursor: pointer;
  &:hover { background: #8e0040; }
  &:disabled { background: #ccc; cursor: not-allowed; }
`;

const ChartButton = styled.button`
  background: ${(p) => (p.active ? "#1890ff" : "#fff")};
  color: ${(p) => (p.active ? "#fff" : "#1890ff")};
  border: 1.5px solid #1890ff;
  border-radius: 6px;
  padding: 7px 20px;
  font-size: 14px;
  cursor: pointer;
  &:hover { background: #1890ff; color: #fff; }
`;

const ReportButton = styled.button`
  background: #fff;
  color: #ae094d;
  border: 1.5px solid #ae094d;
  border-radius: 6px;
  padding: 4px 14px;
  font-size: 13px;
  cursor: pointer;
  &:hover { background: #ae094d; color: #fff; }
`;

const SummaryRow = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

const SummaryCard = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 14px 24px;
  text-align: center;
  min-width: 160px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  .value {
    font-size: 24px;
    font-weight: 700;
    color: #ae094d;
  }
  .title {
    font-size: 12px;
    color: #888;
    margin-top: 4px;
  }
`;

/* ── Grafik ── */
const ChartWrap = styled.div`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 24px 32px 16px;
  margin-bottom: 24px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
`;

const ChartTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
`;

const BarsArea = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 32px;
  height: 220px;
`;

const BarGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex: 1;
`;

const BarOuter = styled.div`
  width: 100%;
  max-width: 100px;
  height: 180px;
  display: flex;
  align-items: flex-end;
  background: #f5f5f5;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
`;

const BarInner = styled.div`
  width: 100%;
  height: ${(p) => p.pct}%;
  background: ${(p) => p.color};
  border-radius: 6px 6px 0 0;
  transition: height 0.5s ease;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const BarValue = styled.span`
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  margin-top: 6px;
`;

const BarLabel = styled.div`
  font-size: 12px;
  color: #555;
  text-align: center;
  max-width: 100px;
`;

const BarPct = styled.div`
  font-size: 11px;
  color: #aaa;
`;

/* ── Modal içi ── */
const ModalTrainerName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

/* ─────────────── */

const BarChart = ({ totalSlots, bookedSlots, completedSlots }) => {
  const pct = (val) => (totalSlots > 0 ? Math.round((val / totalSlots) * 100) : 0);
  const bars = [
    { label: "Total slots", value: totalSlots, color: "#ae094d", pct: 100 },
    { label: "Booked slots", value: bookedSlots, color: "#1890ff", pct: pct(bookedSlots) },
    { label: "Attendance", value: completedSlots, color: "#52c41a", pct: pct(completedSlots) },
  ];
  return (
    <BarsArea>
      {bars.map((bar) => (
        <BarGroup key={bar.label}>
          <BarOuter>
            <BarInner pct={bar.pct} color={bar.color}>
              {bar.pct >= 10 && <BarValue>{bar.value}</BarValue>}
            </BarInner>
          </BarOuter>
          <BarLabel>{bar.label}</BarLabel>
          <BarPct>%{bar.pct}</BarPct>
        </BarGroup>
      ))}
    </BarsArea>
  );
};

const Report = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [list, setList] = useState([]);
  const [activeTrainers, setActiveTrainers] = useState(0);
  const [totalSlots, setTotalSlots] = useState(0);
  const [bookedSlots, setBookedSlots] = useState(0);
  const [completedSlots, setCompletedSlots] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [showChart, setShowChart] = useState(false);

  // Trainer detail modal
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTrainer, setModalTrainer] = useState(null);
  const [modalData, setModalData] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);

  const fetchReport = async () => {
    if (!startDate || !endDate) {
      notification.warning({ message: "Please enter start and end dates." });
      return;
    }
    if (startDate > endDate) {
      notification.warning({ message: "Start date cannot be after the end date." });
      return;
    }
    setLoading(true);
    setSearched(false);
    setShowChart(false);
    try {
      const res = await axios.get(`${API_URL}report/trainer-report`, {
        params: { startDate, endDate },
        withCredentials: true,
      });
      setList(res.data.list || []);
      setActiveTrainers(res.data.activeTrainers || 0);
      setTotalSlots(res.data.totalSlots || 0);
      setBookedSlots(res.data.bookedSlots || 0);
      setCompletedSlots(res.data.completedSlots || 0);
      setSearched(true);
    } catch (err) {
      notification.error({ message: "Failed to load report." });
    } finally {
      setLoading(false);
    }
  };

  const openTrainerModal = async (trainer) => {
    setModalTrainer(trainer);
    setModalData(null);
    setModalOpen(true);
    setModalLoading(true);
    try {
      const res = await axios.get(`${API_URL}report/trainer-detail/${trainer.id}`, {
        params: { startDate, endDate },
        withCredentials: true,
      });
      setModalData(res.data);
    } catch (err) {
      notification.error({ message: "Failed to load tutor report." });
      setModalOpen(false);
    } finally {
      setModalLoading(false);
    }
  };

  const pct = (val) => (totalSlots > 0 ? Math.round((val / totalSlots) * 100) : 0);

  const columns = [
    {
      title: "",
      dataIndex: "image",
      key: "image",
      width: 50,
      render: (img, record) => (
        <Avatar src={record.image_url || img || undefined} style={{ background: "#ae094d" }}>
          {!record.image_url && !img ? (record.first_name?.[0] || "?").toUpperCase() : null}
        </Avatar>
      ),
    },
    {
      title: "Tutor",
      key: "name",
      render: (_, record) => `${record.first_name} ${record.last_name}`,
      sorter: (a, b) =>
        `${a.first_name} ${a.last_name}`.localeCompare(`${b.first_name} ${b.last_name}`),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "",
      key: "action",
      width: 90,
      render: (_, record) => (
        <ReportButton onClick={() => openTrainerModal(record)}>Report</ReportButton>
      ),
    },
  ];

  return (
    <PageWrap>
      <h2 style={{ marginBottom: 20 }}>Tutor appointment report</h2>

      <TopRow>
        <FilterRow>
          <div>
            <Label>Start date</Label>
            <br />
            <DateInput
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div>
            <Label>End date</Label>
            <br />
            <DateInput
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <SearchButton onClick={fetchReport} disabled={loading}>
            {loading ? "Loading..." : "Run report"}
          </SearchButton>
        </FilterRow>

        {searched && (
          <ChartButton active={showChart} onClick={() => setShowChart((v) => !v)}>
            {showChart ? "Hide chart" : "Show chart"}
          </ChartButton>
        )}
      </TopRow>

      {searched && (
        <SummaryRow>
          <SummaryCard>
            <div className="value">{activeTrainers}</div>
            <div className="title">Active tutors</div>
          </SummaryCard>
          <SummaryCard>
            <div className="value">{totalSlots}</div>
            <div className="title">Total slots</div>
          </SummaryCard>
          <SummaryCard>
            <div className="value" style={{ color: "#1890ff" }}>{bookedSlots}</div>
            <div className="title">Booked slots</div>
          </SummaryCard>
          <SummaryCard>
            <div className="value" style={{ color: "#52c41a" }}>{completedSlots}</div>
            <div className="title">Attendance</div>
          </SummaryCard>
        </SummaryRow>
      )}

      {searched && showChart && (
        <ChartWrap>
          <ChartTitle>Slot breakdown (share of total slots created)</ChartTitle>
          <BarChart
            totalSlots={totalSlots}
            bookedSlots={bookedSlots}
            completedSlots={completedSlots}
          />
        </ChartWrap>
      )}

      <Table
        rowKey="id"
        columns={columns}
        dataSource={list}
        loading={loading}
        pagination={{ pageSize: 20 }}
        locale={{ emptyText: searched ? "No data found." : "Pick dates and run the report." }}
      />

      <Modal
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        title={modalTrainer ? `${modalTrainer.first_name} ${modalTrainer.last_name} — Report` : "Report"}
        width={600}
      >
        {modalLoading && <div style={{ textAlign: "center", padding: 40 }}>Loading...</div>}

        {!modalLoading && modalData && (
          <>
            <ModalTrainerName style={{ color: "#888", fontWeight: 400, fontSize: 13, marginBottom: 20 }}>
              {startDate} — {endDate}
            </ModalTrainerName>

            <SummaryRow>
              <SummaryCard>
                <div className="value">{modalData.totalSlots}</div>
                <div className="title">Total slots</div>
              </SummaryCard>
              <SummaryCard>
                <div className="value" style={{ color: "#1890ff" }}>{modalData.bookedSlots}</div>
                <div className="title">Booked slots</div>
              </SummaryCard>
              <SummaryCard>
                <div className="value" style={{ color: "#52c41a" }}>{modalData.completedSlots}</div>
                <div className="title">Attendance</div>
              </SummaryCard>
            </SummaryRow>

            <ChartWrap style={{ marginBottom: 0 }}>
              <ChartTitle>Breakdown chart</ChartTitle>
              <BarChart
                totalSlots={modalData.totalSlots}
                bookedSlots={modalData.bookedSlots}
                completedSlots={modalData.completedSlots}
              />
            </ChartWrap>
          </>
        )}
      </Modal>
    </PageWrap>
  );
};

export default Report;
